"use client";

import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CandidateProfile } from "@/features/common/applicationDetailtOrCandidateProfile";
import { useAuth } from "@/features/auth/context/AuthContext";

export default function TalentProfileView() {
  const { id } = useParams();
  const { t } = useTranslation(["applications"]);
  const { profile } = useAuth();
  if (!id) {
    return <div>{t("messages.error_occurred")}</div>;
  }
  const isTalent = profile?.role === "talent";
  return (
    <CandidateProfile
      id={id}
      breadcrumbs={
        isTalent
          ? undefined
          : [
              { title: t("breadcrumbs.home"), href: "/" },
              { title: t("breadcrumbs.talents"), href: "/applicants" },
              { title: t("navigation.profile_details") }
            ]
      }
    />
  );
}
